import { Typography } from "@mui/material"
import type { FunctionComponent, ReactNode } from "react"

import { getProductShelfLifeTimeFormat } from "../../utils"

import type { Product } from "@/graphql/codegen/graphql"
import { TechnicalInformationCasNumbers } from "@/screens/Products/components/Product/Information/TechnicalInformation/TechnicalInformationCasNumber"

interface TechnicalInformationListProps {
  productDetails: Pick<
    Product,
    | "chemicalName"
    | "specificGravity"
    | "shelfLifeDays"
    | "casRegistryIds"
    | "harmonizedTariffSchedule"
    | "usmcaClass"
    | "unNumber"
  >
}

const renderTechnicalInfoItem = (label: string, value: ReactNode, key: number) => (
  <div key={key} className='flex min-h-[54px] items-center border-b border-gray-500'>
    <Typography variant='body2' className='flex-1 text-left text-gray-900'>
      {label}
    </Typography>
    <Typography variant='body2' className='flex-1 text-left text-sm'>
      {value || "-"}
    </Typography>
  </div>
)

export const TechnicalInformationList: FunctionComponent<TechnicalInformationListProps> = ({ productDetails }) => {
  const shelfLifeDays = productDetails.shelfLifeDays || 0
  const { divisible, format } = getProductShelfLifeTimeFormat(shelfLifeDays)

  const technicalInfoItems = [
    { label: "Chemical Name:", value: productDetails.chemicalName },
    { label: "Specific Gravity:", value: productDetails.specificGravity },
    {
      label: `Shelf Life (${format})`,
      value: (shelfLifeDays / divisible).toFixed(1).replace(/\.?0+$/, ""),
    },
    {
      label: "CAS:",
      value: <TechnicalInformationCasNumbers casRegistryIds={productDetails.casRegistryIds as string[]} />,
    },
    { label: "HTS:", value: productDetails.harmonizedTariffSchedule },
    { label: "USMCA (NAFTA):", value: productDetails.usmcaClass ? "Selected" : "Not Selected" },
    { label: "UN Number:", value: productDetails.unNumber },
  ]

  return (
    <div className='mr-20'>
      {technicalInfoItems.map((item, index) => renderTechnicalInfoItem(item.label, item.value, index))}
    </div>
  )
}
